import React, { Component } from "react";
import classNames from "classnames";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";

import startImage from "../../images/icon-start-app.svg";
import clientsIcon from "../../images/icon-submit_lead.svg";
import houses from "../../images/home-houses.svg";
import ivantage from "../../images/home-ivantage.jpg";

import NavButton from "./components/NavButton";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
       search: "",
       agencyUserName: ""
    };

    this.onHandleKeyPress = this.onHandleKeyPress.bind(this);
  }

  componentDidMount() {
    axios.get(`${BACKEND_CONFIG.apiUrl}users`)
      .then((data) => {
        this.setState({
          agencyUserName: data.data.agencyUserName
        })
      });
  }

  onHandleKeyPress(e) {
    if (e.nativeEvent.keyCode === 13) {
      this.props.history.push({
        pathname: "/your-clients",
        query: { search: e.target.value },
      });
    }
  }

  render() {
    return (
      <div className="home-page x-vertical x-align-middle-center">
        <div>
          <h1 data-testid="home-page-heading-label">
            Welcome to My Commercial Exchange
          </h1>
          <h2 className={classNames("home-username", this.state.agencyUserName && "visible")}>
            {this.state.agencyUserName || "⋯"}
          </h2>
          <img alt="home" className="houses-logo" src={houses} />
          <h3>
            Here, it's easy to quote commercial coverage via<br/> the{" "}
            <img src={ivantage} height={34} alt="" />{" "}
            expanded markets program
          </h3>
          <div className="home-buttons">
            <NavButton
              imagesrc={startImage}
              isPrimary={true}
              title="Start New Quote"
              link="/start-application"
            />
            <div style={{ display: "none" }}>
              <NavButton
                imagesrc={clientsIcon}
                isPrimary={false}
                title="Submit a Lead"
                link="/lead-form"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
